<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      d="M6.8 3.8C4.7 3.8 3 5.4 3 7.5c0 2.3 1.3 4.7 3.4 7.1 1.7 2 3.8 3.8 5.6 5.3 1.8-1.5 3.9-3.3 5.6-5.3 2-2.4 3.4-4.8 3.4-7.1 0-2-1.7-3.7-3.8-3.7s-3.8 1.7-3.8 3.7c0 .4-.2.8-.4 1.1-.2.2-.6.4-1 .4s-.8-.2-1.1-.4c-.3-.3-.4-.7-.4-1.1 0-2.1-1.7-3.7-3.7-3.7zm5.2-.6c-.6-.8-1.4-1.4-2.3-1.8C8.7 1 7.8.7 6.8.8 3 .8 0 3.7 0 7.5c0 3.4 1.9 6.5 4.1 9.1 2.2 2.6 4.9 4.8 7 6.4.3.2.6.3.9.3.3 0 .7-.1.9-.3 2-1.6 4.8-3.8 7-6.4C22.1 14 24 10.8 24 7.5c0-3.7-3-6.7-6.8-6.7-2.1 0-4 .9-5.2 2.4z"
      fill-rule="evenodd"
      fill="currentColor"
    />
  </svg>
</template>
